import { render } from "./AsideMenuItem.vue?vue&type=template&id=00147fbc&scoped=true"
import script from "./AsideMenuItem.vue?vue&type=script&lang=js"
export * from "./AsideMenuItem.vue?vue&type=script&lang=js"

import "./AsideMenuItem.vue?vue&type=style&index=0&id=00147fbc&scoped=true&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00147fbc"]])

export default __exports__